export default function FormatZipCode(value: string) {
  var r = value.replace(/\D/g, "")
  if (r.length > 6) {
    r = r.slice(0, 6)
  }
  return r
}

export function ValidZipCode(postalCode: string) {
  postalCode = postalCode.toString().toUpperCase()

  var us = new RegExp("^\\d{5}(-{0,1}\\d{4})?$")
  var ca = new RegExp(/^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z][ ][0-9][ABCEGHJ-NPRSTV-Z][0-9]$/)

  if (us.test(postalCode)) {
      return true
  }

  if (ca.test(postalCode)) {
      return true
  }
  return false
}
